export default __webpack_public_path__ + "static/media/deltaflightmuseum.2e33f6d6.jpeg";